import DashboardIcon from "@mui/icons-material/Dashboard";
import GroupIcon from "@mui/icons-material/Group";
import SecurityIcon from "@mui/icons-material/Security";
import SettingsIcon from "@mui/icons-material/Settings";
import { MessageCircle, Shield, User } from "lucide-react";
import { SquareChartGantt, Workflow } from "lucide-react";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import AutoModeIcon from "@mui/icons-material/AutoMode";
import CampaignIcon from "@mui/icons-material/Campaign";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import SmartToyIcon from "@mui/icons-material/SmartToy";

import AssessmentIcon from "@mui/icons-material/Assessment";

export const menuItems = [
  {
    label: "Dashboard",
    path: "/dashboard",
    icon: <DashboardIcon />,
  },

  {
    label: "Pipelines",
    path: "/pipelines",
    icon: <Workflow />,
    expandable: true,
  },
  {
    label: "Leads",
    path: "/leads",
    icon: <SquareChartGantt />,
    expandable: true,
  },

  {
    section: "Reports",
    label: "Reports",
    path: "/reports",
    icon: <AssessmentIcon />,
  },

  {
    section: "Admin Panel",
    label: "Users",
    path: "/users",
    icon: <GroupIcon />,
  },
  {
    section: "Admin Panel",
    label: "Teams",
    path: "/teams",
    icon: <Shield />,
  },
  // {
  //   label: "Roles",
  //   path: "/roles",
  //   icon: <SecurityIcon />,
  // },
  {
    label: "Settings",
    path: "/settings",
    icon: <SettingsIcon />,
  },
  {
    label: "Chat",
    path: "/chat/inbox",
    icon: <WhatsAppIcon />,
    // expandable removed - Chat now directly navigates to inbox
  },
  {
    label: "Campaign",
    path: "/campaign",
    icon: <CampaignIcon />,
  },
  {
    label: "Automation",
    path: "/automation/rules",
    icon: <AutoModeIcon />,
  },
  {
    label: "AI Master Control",
    path: "/ai-master-control",
    icon: <SmartToyIcon />,
  },
  { label: "Knowledge Base",
    path: "/knowledge-base",
    icon: <MenuBookIcon />,},
  {
    label: "Support Chat",
    path: "/ticket",
    icon: <SupportAgentIcon />,
  },
];
